import React from 'react';

export const KeyClaimsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11990_96615)">
        <path
          d="M8.16602 8.16699C8.47543 8.16699 8.77218 8.04408 8.99097 7.82528C9.20977 7.60649 9.33268 7.30974 9.33268 7.00033V4.66699H8.16602"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8327 9.91667C12.8327 10.2261 12.7098 10.5228 12.491 10.7416C12.2722 10.9604 11.9754 11.0833 11.666 11.0833H3.98235C3.67295 11.0834 3.37626 11.2064 3.15752 11.4252L1.87302 12.7097C1.81509 12.7676 1.7413 12.807 1.66097 12.823C1.58063 12.839 1.49737 12.8308 1.42169 12.7994C1.34602 12.7681 1.28134 12.715 1.23583 12.6469C1.19032 12.5788 1.16603 12.4987 1.16602 12.4168V2.91667C1.16602 2.60725 1.28893 2.3105 1.50772 2.09171C1.72652 1.87292 2.02326 1.75 2.33268 1.75H11.666C11.9754 1.75 12.2722 1.87292 12.491 2.09171C12.7098 2.3105 12.8327 2.60725 12.8327 2.91667V9.91667Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66602 8.16699C4.97543 8.16699 5.27218 8.04408 5.49097 7.82528C5.70977 7.60649 5.83268 7.30974 5.83268 7.00033V4.66699H4.66602"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11990_96615">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
